<script setup lang="ts">
import { helpers, required } from "@vuelidate/validators";
import { computed, reactive, ref, toRefs } from "vue";
import {
  FormInput,
  FormLabel,
  FormCheck,
  FormSelect
} from "../../../base-components/Form";
import Preview from "../../../base-components/Preview";
import { IScanntechPOSConfig } from "@fixeduy/restaurantestypes";

interface Props {
  indice: number;
  pos: IScanntechPOSConfig | null;
}

const props = defineProps<Props>();
const emit = defineEmits<{
  (e: "actualizar", data: { indice: number; pos: IScanntechPOSConfig }): void;
}>();

// const localesStore = useLocalesStore();

const formData = reactive({
  nombre: props.pos?.nombre ?? "",
  localFixed: props.pos?.localFixed ?? "",
  Local: props.pos?.Local ?? "",
  PosID: props.pos?.PosID ?? "",
  imprime: props.pos?.imprime ?? true,
  Caja: props.pos?.Caja ?? ""
});

const rules = {
  nombre: {
    required: helpers.withMessage(
      "El campo nombre no puede estar vacío",
      required
    )
  },
  local: {
    required: helpers.withMessage(
      "El campo local no puede estar vacío",
      required
    )
  },
  PosID: {
    required: helpers.withMessage(
      "El campo PosID no puede estar vacío",
      required
    )
  },
  imprime: {
    required: helpers.withMessage(
      "El campo imprime no puede estar vacío",
      required
    )
  }
};

const actualizar = () => {
  const datos: IScanntechPOSConfig = {
    nombre: formData.nombre,
    Local: formData.Local,
    localFixed: formData.localFixed,
    PosID: formData.PosID,
    Caja: formData.Caja,
    imprime: formData.imprime
  };
  emit("actualizar", { indice: props.indice, pos: datos });
};
</script>

<template>
  <Preview class="box mt-2">
    <div class="border">
      <div class="flex flex-row rounded-md w-full space-x-3">
        <div class="flex-1 p-3">
          <div class="flex">
            <div class="flex-none w-50 text-right pr-5 mt-2">
              <FormLabel> Nombre (interno Atiendo) </FormLabel>
            </div>
            <div class="flex-1">
              <FormInput
                type="text"
                v-model.trim="formData.nombre"
                placeholder="Nombre"
                @change="actualizar"
              />
            </div>
          </div>
        </div>
        <div class="flex-1 p-3">
          <div class="flex">
            <div class="flex-none w-50 text-right pr-5 mt-2">
              <FormLabel> PosID (brindado por OCA) </FormLabel>
            </div>
            <div class="flex-1">
              <FormInput
                type="text"
                v-model.trim="formData.PosID"
                placeholder="PosID"
                @change="actualizar"
              />
            </div>
          </div>
        </div>
        <div class="flex-1 p-3">
          <div class="flex">
            <div class="flex-none w-50 text-right pr-5 mt-2">
              <FormLabel> Local Atiendo</FormLabel>
            </div>
            <div class="flex-1">
              <FormSelect
                v-model="formData.localFixed"
                id="local"
                @change="actualizar"
              >
                <option value="" disabled>Local</option>

                <!-- <option
                  v-for="local in localesStore.localesActivos"
                  :key="local.id"
                  :value="local.id"
                >
                  {{ local.nombre }}
                </option> -->
              </FormSelect>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-row rounded-md w-full space-x-4">
        <div class="flex-1 p-3">
          <div class="flex">
            <div class="flex-none w-50 text-right pr-5 mt-2">
              <FormLabel> Local (brindado por Scanntech) </FormLabel>
            </div>
            <div class="flex-1">
              <FormInput
                type="text"
                v-model.trim="formData.Local"
                placeholder="Local"
                @change="actualizar"
              />
            </div>
          </div>
        </div>
        <div class="flex-1 p-3">
          <div class="flex">
            <div class="flex-none w-50 text-right pr-5 mt-2">
              <FormLabel> Caja (brindado por Scanntech)</FormLabel>
            </div>
            <div class="flex-1">
              <FormInput
                type="text"
                v-model.trim="formData.Caja"
                placeholder="Caja"
                @change="actualizar"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="flex-1 p-3">
        <div class="flex">
          <div class="flex-none w-50 text-right pr-5 mt-2">
            <FormLabel>
              Pos imprime voucher (muy importante que esté bien configurado por
              las reversas)</FormLabel
            >
          </div>
          <div class="flex-1">
            <FormCheck.Input
              id="checkbox-switch-1"
              type="checkbox"
              v-model="formData.imprime"
              @change="actualizar"
            />
          </div>
        </div>
      </div>
    </div>
  </Preview>
</template>
